export default {
  init() {
    $(".nav-primary .products").addClass("single-parent");

    $('.creed-screw-wrap p').click(function () {
      $('.creed-screw-wrap p').removeClass('active');
      $(this).addClass('active');
      var img = $(this).data('img');
      var selectedImg = document.getElementsByClassName(img);
      $('.creed-screw-wrap img').removeClass('active');
      $(selectedImg).addClass('active');
    });
  }
};



// WEBPACK FOOTER //
// ./scripts/routes/single-product.js